/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import classes from "../style";
import { DestinationBlog } from "models/Destination";
import destinationBlogService from "services/destinationBlogService";
import { getImageUrl } from "utils/imageUtils";
import { getArticlePath } from "utils/articleUrl";

const CarnetVoyage: FC<{}> = () => {
  const [blogs, setBlogs] = useState<DestinationBlog[]>([]);
  const [page, setPage] = useState(0);

  useEffect(() => {
    load();
  }, [page]);

  const load = async () => {
    setBlogs([...blogs, ...await destinationBlogService.getList(page)]);
  }

  const nextPage = async () => {
    const p = page + 1;
    setPage(p);
  }

  const getImage = (blog: DestinationBlog): string => {
    const imgs = blog.destinationBlogPictures;
    const main = imgs.find(i => i.mainPicture);

    if (main) {
      return getImageUrl(main.url);
    }

    return imgs.length > 0 ? getImageUrl(imgs[0].url) : null;
  }

  return <Container sx={classes.destinationsBloc}>
    <Typography variant="h1" my={5}>
      EXPLORER LE MONDE
    </Typography>
    <Grid container spacing={3}>
      {blogs.map((blog) => (
        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardMedia
              component="img"
              height="140"
              image={`${getImage(blog)}`}
              alt={blog.title}
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                {blog.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#000",
                }}
              >
                {blog.description}
              </Typography>
            </CardContent>
            <CardActions>
              <Link to={getArticlePath(blog.id, blog.title)}>
                <Button variant="contained" size="small">
                  Lire plus
                </Button>
              </Link>
            </CardActions>
          </Card>
        </Grid>
      ))}
    </Grid>
    <Button variant="text" size="small" sx={classes.linkBtn} onClick={() => nextPage()}>
      {" "}
      Plus d&apos;articles
    </Button>
  </Container>
};

export default CarnetVoyage;
